import React from 'react';
import { Loader } from 'lucide-react';

export const ModalActions = ({
  onCancel,
  loading = false,
  submitLabel = 'Save',
  loadingLabel = 'Saving...',
  submitIcon: SubmitIcon,
  disabled = false
}) => {
  return (
    <div className="flex justify-end space-x-3 pt-6 border-t border-gray-200">
      <button
        type="button"
        onClick={onCancel}
        disabled={loading}
        className="px-6 py-3 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors font-medium disabled:cursor-not-allowed disabled:opacity-50"
      >
        Cancel
      </button>
      <button
        type="submit"
        disabled={loading || disabled}
        className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center transition-colors font-medium"
      >
        {loading ? (
          <>
            <Loader className="animate-spin mr-2" size={16} />
            {loadingLabel}
          </>
        ) : (
          <>
            {SubmitIcon && <SubmitIcon className="mr-2" size={16} />}
            {submitLabel}
          </>
        )}
      </button>
    </div>
  );
};
